import { render, staticRenderFns } from "./catalog-search.vue?vue&type=template&id=abf6af60&scoped=true&"
import script from "./catalog-search.ts?vue&type=script&lang=ts&"
export * from "./catalog-search.ts?vue&type=script&lang=ts&"
import style0 from "./catalog-search.scss?vue&type=style&index=0&id=abf6af60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf6af60",
  null
  
)

export default component.exports